import { Button, Modal, Dropdown } from "react-bootstrap";
import AppLoader from 'components/general/AppLoader';
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useState } from "react";

export default function DeleteModal({ announcement, getAnnouncements }) {
  const { user: authUser } = useSelector((x) => x.auth);

  const url = process.env.REACT_APP_URL;

  const [saveLoading, setSaveLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveLoading(true);

    try {
      const response = await fetch(`${url}/announcement/${announcement._id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authUser.token}`,
        },
      });

      if (response.status === 200) {
        await response.json();
        toast.success(`Announcement ${announcement.title} deleted successfully`, {
          position: "bottom-left",
        });
        getAnnouncements(); // Refresh the announcement list
        handleCloseModal();
      } else {
        console.log(response);
        toast.error(`Failed to delete announcement ${announcement.title}. Error: ${response.status}`, { position: "bottom-left" });
      }
    } catch (error) {
      console.error(error);
      toast.error(`Failed to delete announcement ${announcement.title} - Error: ${error}`, { position: "bottom-left" });
    } finally {
      setSaveLoading(false);
    }
  }
  return (
    <>
      <Dropdown.Item onClick={handleShowModal} variant="danger" className="mb-1 float-end">
        Delete Announcement
      </Dropdown.Item>
      <Modal show={showModal} onHide={handleCloseModal} className="text-center" data-bs-theme={"dark"} size="lg" style={{ top: "2%" }}>
        <Modal.Header closeButton >
          <Modal.Title>Delete Announcement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete announcement {announcement.title}?
        </Modal.Body>
        <Modal.Footer>
          {saveLoading ? (
            <Button variant="secondary" disabled>
              <AppLoader size="sm" inline /> Saving...
            </Button>
          ) : (
            <>
              <Button variant="danger" onClick={handleSubmit}>
                Delete
              </Button>
              <Button variant="dark" onClick={handleCloseModal}>
                Cancel
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}